/**
 * Created by bob.gear on 31/05/2015.
 */
/*
 Experimental directive for coalescing all the requirements for daplaying project summaries

 The component should be highly focussed on the project summary list and eliminate the need for
 summary base and subclasses.

 Although I don't really want an isolated scope for the component, I do need to be able to
 provide different (but compatible) data services. The logical way to do this would seem to
 be a binding so that whatever is outside is not directly referenced from the inside.

 An isolate scope would better define the interface - and theoretically define the actual
 methods to be provided quite explicitly.

 this will also bve an ideal opportunity to  further rationalise the contents of the main controller

 */
/*
  project-summary directive
  takes a list of project summaries and displays on screen - taking account of tracking status
  selections and requested sort order
 */
angular.module('EICDataStream3.projectDisplayModule', ["infinite-scroll"])
  .directive('projectSummaryDirective',
    function () {
      return {
        // it is highly likely that a new scope should not be declared in this instance
        //   1. there will only ever be one instance active at a time
        //   2. an isolated scope introduces additional complexity
        // On the other hand, an isolate scope will closely define the interface that it
        // presents to the outside - especially useful when considering the data service
        // if we isolate the scope, this is where all the directive i/o
        // would be declared eg:
        replace: true,
        //template: "<div>{{customer.name}}</div>",
        //templateUrl: '../app-ds3/projectSummary/projectSummary.tmpl.html',
        templateUrl: function (element, attributes) {
          // This is a new method that  will render a different tamplat if 
          // the screen is too narrow to accept a full size table
          // Note that  this is NOT responsive to the extent of chnging size 
          // dynamically if the window is resized
          if (window.innerWidth < 825) {
            return '../app-ds3/projectSummary/projectSummary-mobile.tmpl.html';
          }
          else {
            return '../app-ds3/projectSummary/projectSummary.tmpl.html';
          }
        },

        scope: {
          //  trackingStatuses:  '@',             // 1-way binding because we never have to write back to the parent
          //watchId:  '=',
          getNextPage: '&', // function binding to  a service function available to the parent
          restoreProject: '&', // function binding to  a service function available to the parent
          showAllTrackingStatuses: '=',
          selectedTrackingStatuses: '=',
          projects: '=',
          highlightDays: '=',
          highlightSince: '=',
          sortField: '@',
          sortDesc: '@',
          moreSummaries: '=',
          allowProjectSelection: '=',
          indicateNewProjects: '=',
          newSince: '=',
          projectSelectionSummary: "="

        },
        compile: function compile(tElement, tAttrs, transclude) {
          // if the allowProjectSelections attribute has not been specified, add it to the list  of attributes
          // to be processed with a default true value
          if (!angular.isDefined(tAttrs.allowProjectSelection)) {
            tAttrs.allowProjectSelection = "true";
          }
          return {
            pre: function preLink(scope, iElement, iAttrs, controller) { },
            post: function postLink(scope, iElement, iAttrs, controller) {
              //  scope.allTrackingStatuses = scope.allTrackingStatuses ? true : false
              //  if(scope.allTrackingStatuses){
              //    scope.selectedTrackingStatuses =  [1,3,4,5,6,7] // or whatever the valid values are
              //  }
            }
          }
          // or
          // return function postLink( ... ) { ... }
        },
        controller: 'ProjectSummaryDirectiveController'

      };
    })
  .controller('ProjectSummaryDirectiveController',
    [
      '$scope', '$timeout', 'projectNavigationService', 'projectDataService', 'themeService',
      function ($scope, $timeout, projectNavigationService, projectDataService, themeService) {
        $scope.componentName = "ProjectSummaryDirectiveController";

        $scope.theme = themeService;

        $scope.isMobile = window.width < 825;

        //----------------------------------------------------------------------------------
        // Project Highlighting
        //----------------------------------------------------------------------------------
        // Sets the highlight style on projects that  have ven updated more recently than
        // the specified number of days or since the specified date
        // Behaviour is not guaranteed to be correct ids both parameters are set
        //----------------------------------------------------------------------------------
        $scope.projectSummaryStyle = function (item) {
          var highlightStyle = { "background-color": "#FF91A4" };
          var excludedStyle = { "background-color": "#ddd", 'color': '#888', 'text-decoration': 'line-through' };

          var returnStyle = {};

          if (item.excluded) {
            returnStyle = excludedStyle;
          } else {
            var projectUpdated = new Date(item.projectUpdated);
            projectUpdated.setHours(0, 0, 0, 0);

            if ($scope.highlightDays) {
              var today = new Date();
              today.setHours(0, 0, 0, 0);

              // javascript date differences are in milliseconds
              var timeDiff = Math.abs(projectUpdated.getTime() - today.getTime());
              var daysAgo = -Math.ceil(timeDiff / (1000 * 3600 * 24));

              if (daysAgo >= $scope.highlightDays) returnStyle = highlightStyle;

            } else if ($scope.highlightSince) {
              var sinceDate = new Date($scope.highlightSince);
              sinceDate.setHours(0, 0, 0, 0);

              var dateDiff = projectUpdated.getTime() - sinceDate.getTime();
              if (dateDiff >= 0) returnStyle = highlightStyle;

            }

          }

          return returnStyle;
        };


        $scope.highlightProjectMobile = function (item) {
          var projectUpdated = new Date(item.projectUpdated);
          projectUpdated.setHours(0, 0, 0, 0);

          var defaultPanelClass = 'panel-default';
          var highlightPanelClass = 'panel-project-highlight';
          var excludedClass = 'panel-project-excluded';

          var returnClass = defaultPanelClass;

          if (item.excluded) {
            returnClass = excludedClass;
          }
          else {
            if ($scope.highlightDays) {
              var today = new Date();
              today.setHours(0, 0, 0, 0);

              // javascript date differences are in milliseconds
              var timeDiff = Math.abs(projectUpdated.getTime() - today.getTime());
              var daysAgo = -Math.ceil(timeDiff / (1000 * 3600 * 24));

              returnClass = (daysAgo >= $scope.highlightDays)
                ? highlightPanelClass
                : defaultPanelClass;

            }
            else if ($scope.highlightSince) {
              var sinceDate = new Date($scope.highlightSince);
              sinceDate.setHours(0, 0, 0, 0);

              var dateDiff = projectUpdated.getTime() - sinceDate.getTime();

              returnClass = (dateDiff >= 0)
                ? highlightPanelClass
                : defaultPanelClass;
            }
          }
          return returnClass;
        }
        //----------------------------------------------------------------------------------


        $scope.projectIsNew = function (projectCreated) {
          var projectCreated = new Date(projectCreated);
          // projectCreated.setHours(0,0,0,0);
          var sinceDate = new Date($scope.newSince);
          // sinceDate.setHours(0,0,0,0);

          var dateDiff = projectCreated.getTime() - sinceDate.getTime();

          return (dateDiff >= 0);
        };
        //----------------------------------------------------------------------------------

        //----------------------------------------------------------------------------------
        // Project Navigation sorting
        //----------------------------------------------------------------------------------
        // Implemented though a service to keep details about project data
        // and state transitions out of the directive and its controller
        //----------------------------------------------------------------------------------
        $scope.openProject = function (item, allowRevertToSummary) {
          if (!item.excluded) {
            projectNavigationService.gotoProject(item.projectID, item.projectName, allowRevertToSummary);
          }

        };
        //----------------------------------------------------------------------------------


        //----------------------------------------------------------------------------------
        // Project Visibility
        //----------------------------------------------------------------------------------
        // Depending on the selected tracking statuses, projects will be either hidden
        // or visible
        //----------------------------------------------------------------------------------
        $scope.projectIsHidden = function (project) {
          return $scope.showAllTrackingStatuses
            ? false
            : ($scope.selectedTrackingStatuses.indexOf(project.trackingStatusID) == -1);
        };
        //----------------------------------------------------------------------------------


        //----------------------------------------------------------------------------------
        // Project Selection
        //----------------------------------------------------------------------------------
        // Ability to  select projects for use with report and watch requests
        // by  maintaining the same interface as searchSummary.js, I can make this
        // transition  nice ans smooth. However, it would be best to  abstract the
        // reference to projectDataService
        //----------------------------------------------------------------------------------

        // master control for whether whether project selectors are visible or not
        $scope.showProjectSelectors = false;

        // function to enable project selectors (actuated from on screen control)
        // sets the project selectors to visible (*with animation)
        // then sets a timeout to  hide tje selectors after an interval
        // if no projects are selected
        $scope.enableProjectSelectors = function () {
          $scope.showProjectSelectors = true;

          $timeout(function () {
            if (!$scope.areAnyProjectsChecked()) {
              $scope.showProjectSelectors = false;
            }
          },
            5000)
        };

      //   // selector surround styling
      //   var projectSelector_Enabled_Border = {};
      //  // var projectSelector_Disabled_Border = { "background-color": "white", "border-top": "white" };
      //   var projectSelector_Disabled_Border = { "background-color": $scope.theme.surface, "border-top": $scope.theme.surface };
      //   $scope.projectSelectorBorder = projectSelector_Disabled_Border
      //   $scope.$watch("showProjectSelectors",
      //     function (newValue, oldValue) {
      //       if (newValue) {
      //         $scope.projectSelectorBorder = "";
      //       } else {
      //         $scope.projectSelectorBorder = "projectSelectorBorder"
      //           //{ "background-color": $scope.theme.surface, "border-top": $scope.theme.surface };
      //       }
      //     });


        // status of the areAllProjectsChecked flag
        // this value is watched and all the projects are either selected or deselected,
        // depending on its value
        $scope.areAllProjectsChecked_changed = function (newValue) {
          toggleAllProjects(newValue);

          $scope.projectSelectionSummary.areAnyProjectsSelected = newValue;
          $scope.projectSelectionSummary.areAllProjectsSelected =
            ($scope.projectSelectionSummary.numberOfProjectsSelected == projectDataService.projectNames.length);
        }

        $scope.areAllProjectsChecked = false;

        var toggleAllProjects = function (value) {
          $scope.projectSelectionSummary.areAllProjectsSelected = value;

          if (value) {
            $scope.projectSelectionSummary.projectIDs = projectDataService.projectNames.map(function (pn) {
              return pn.projectID;
            });
          }
          else {
            $scope.showProjectSelectors = false;
            $scope.projectSelectionSummary.projectIDs.length = 0;
          }


          // toggle all projects needs to respect the tracking status
          // selection that is already active.
          angular.forEach(projectDataService.projectNames,
            function (item) {
              if ($scope.showAllTrackingStatuses ||
                $scope.selectedTrackingStatuses.indexOf(item.trackingStatusID) > -1) {
                item.isChecked = value;

                if (value) $scope.projectSelectionSummary.numberOfProjectsSelected++;
                else $scope.projectSelectionSummary.numberOfProjectsSelected--;
              }
            });
        };


        //// Function to determine if any projects in the list have been selected
        //// This is used to determine which options are available on the
        //// Actions menu
        //$scope.areAnyProjectsChecked = function(){
        //  if(!projectDataService.projectNames) return false;
        //
        //  // Iterate through the projectName objects checking isChecked
        //  // The first one to  be found to be true indicates that at least
        //  // one project has been selected so immediately return true.
        //  for( i=0; i< projectDataService.projectNames.length; i++ ){
        //    if(projectDataService.projectNames[i].isChecked) return true;
        //  }
        //
        //  // since we got here, we know that none of the items are selected
        //  return false;
        //};


        // Function to  return the projectName object that  relates to  an
        // on-screen summary row. The Whole list  of projectName objects has been
        // put into an associative array to  make the lookup easy
        // The checkbox is bound to the isChecked property of the returned object
        // based on the projectID
        $scope.projectChecked_changed = function (projectNameItem) {
          // during initial population, isChecked is undefined, so skip;
          // there is nothing to do

          //if(isChecked == undefined) return;
          // var p =        $scope.getProjectName(projectID)

          // If digest cycle takes us through this multiple times and the value has
          // already been set, skip; there is nothing to do
          // if(p.isChecked == isChecked) return;
          var projectID = projectNameItem.projectID;
          var isChecked = projectNameItem.isChecked;

          $scope.projectSelectionSummary.projectSelecting(projectID, isChecked);
          // p.isChecked = isChecked;
          if (isChecked) {
            // add the projectID to the array (creating the array if it does not already exist
            // care! how do we make sure this array goes out of scope so it doesn't need
            // further maintenance between views?
            // $scope.projectSelectionSummary.numberOfProjectsSelected++;
            if (!$scope.projectSelectionSummary.projectIDs) $scope.projectSelectionSummary.projectIDs = [];
            $scope.projectSelectionSummary.projectIDs.push(projectID);
          } else {
            // remove the item from the array
            // $scope.projectSelectionSummary.numberOfProjectsSelected--;
            var index = $scope.projectSelectionSummary.projectIDs.indexOf(projectID);
            if (index > -1) $scope.projectSelectionSummary.projectIDs.splice(index, 1);
          }
          $scope.projectSelectionSummary.numberOfProjectsSelected = $scope.projectSelectionSummary.projectIDs.length;
          $scope.projectSelectionSummary.projectSelected(projectID, isChecked);

          $scope.projectSelectionSummary.areAnyProjectsSelected =
            ($scope.projectSelectionSummary.numberOfProjectsSelected > 0);

          $scope.projectSelectionSummary.areAllProjectsSelected =
            ($scope.projectSelectionSummary.numberOfProjectsSelected === projectDataService.projectNames.length);

        };

        $scope.getProjectName = function (projectID, isChecked) {
          return projectDataService.projectNameLookup[projectID];
        };

        //// Restore a previously removed project
        //// this is what  happens on a project watch when the user chooses projects
        //// and clicks 'Stop watching selected projects)' on the Actions Menu
        $scope.restoreSelectedProject = function (projectID) {
          // the exact action to  take depends on the watch type.
          // Selected project watches - re-add the projectID
          // dynamic project watches - delete the project from the ignore list
          // In either case, form a path record an send it up fo rthe
          // API t o decode and deal with.
          // On success, restyle the project line

          // this action should be provided from outside by the container
          // so that the undo action can be handled appropriately to
          // the circumstances.
          $scope.restoreProject()(projectID).then(function () {
            var nameItem = projectDataService.projectNameLookup[projectID];
            nameItem.isChecked = false;
          });

        };
        //////////////////////////////////////////////////////////////////////

        //----------------------------------------------------------------------------------


      }
    ])
  .service("projectNavigationService",
    [
      '$state', '$stateParams', 'projectDataService',
      function ($state, $stateParams, projectDataService) {
        this.stateParams = {};

        // I'm not really sure what  this is for, since the value is identical to
        // the route that  is navigated to below. For investgation and possible
        // removal
        projectDataService.projectRoute = 'search.project';

        this.sourceRoute = "";
        // this.stateParams = $stateParams;

        this.gotoProject = function (projectID, projectName, allowRevertToSummary) {
          // use angular.extend acting on an empty object  to
          // clone the current state of the $stateparams
          // if this is not done. further state changes alter the $stateparams so
          // they  cannot be used for the return trip
          var returnStateParams = angular.extend({}, $stateParams);
          var returnRoute = $state.current;

          // pass in an object containing everything needed for the project service
          // to return to the current page.
          // for more general use, the caption and return route need to be parameterised
          projectDataService.revert = {
            allow: allowRevertToSummary,
            caption: "Return to Results Summary",
            go: function () {
              $state.go(returnRoute, returnStateParams);

              //   $state.go('projectWatch', returnStateParams);
            }
          };

          $state.go('search.project', { projectID: projectID, projectName: projectName.urlEncode() });
        };

      }
    ])

  //----------------------------------------------------------------------------------
  // Column sorting for project summarues
  //----------------------------------------------------------------------------------
  // This implementation does not save a new search definition, or implement a
  // URL parameter (or similar mechanism
  // Consequently this is not a bookmarkable change, which might be a valuable
  // additional feature
  //----------------------------------------------------------------------------------
  .service("projectSummarySortService",
    [
      'searchService', 'projectSummaryDataService',
      function (searchService, projectSummaryDataService) {

        var projectSummarySortService = this;

        // initial values are whatever was stored in the querydef (or Project Name by default
        projectSummarySortService.sortOrder = searchService.queryDef.sorting.sort_order || "ProjectName";
        projectSummarySortService.sortDesc = searchService.queryDef.sorting.sort_desc;

        projectSummarySortService.sort = function (sort) {
          searchService.queryDef.sorting.sort_order = sort.sortField;
          searchService.queryDef.sorting.sort_desc = sort.sortDesc;

          projectSummarySortService.sortOrder = sort.sortField;
          projectSummarySortService.sortDesc = sort.sortDesc;

          searchService.queryDef.paging.offset = 0;
          projectSummaryDataService.items = [];
          projectSummaryDataService.dataFlowControl.items = [];

          projectSummaryDataService.count = 0;

          projectSummaryDataService.projectSearch();
        };

      }
    ]);


//<div my-method='theMethodToBeCalled(id)'></div>
//
//
//app.directive("myMethod",function($parse) {
//  restrict:'A',
//    link:function(scope,element,attrs) {
//    // here you can parse any attribute (so this could as well be,
//    // myDirectiveCallback or multiple ones if you need them )
//    var expressionHandler = $parse(attrs.myMethod);
//    $(element).on('theEvent',function( e, rowid ) {
//      calculatedId = // some function called to determine id based on rowid
//
//        // HERE: call the parsed function correctly (with scope AND params object)
//        expressionHandler(scope, {id:calculatedId});
//    }
//  }
//}

//app.controller("myController",function($scope) {
//  $scope.theMethodToBeCalled = function(id) { alert(id); };
//}

/***************************************************************************************************************
 * The following is from the favourites summary
 ***************************************************************************************************************/

/**
 * Created by bob.gear on 30/05/2015.
 */
/*
 Now here's the thing - all of the project summary  controllers and layouts are called from
 the search module.

 This is not what I  want longer term. There is a base class for the project summary which
 should be able to exist in one module, then I want to be able to subclass (prototypically)
 in another module so that, notifications, say, can inherit and extend the behaviour
 */
//var EICDataStream3ProjectNotifications = angular.module('EICDataStream3.projectNotifications', []) // <-- add dependencies here
//
//  .controller('ProjectNotificationsSummaryController', ['$scope', '$controller', '$stateParams', '$state', 'dialogs', 'favouriteListSummaryDataService', 'projectDataService',
//    function ($scope, $controller, $stateParams, $state, dialogs, favouriteListSummaryDataService, projectDataService) {
//      $controller('BaseSummaryController', { $scope: $scope }); //This works
//
//      $scope.componentName = "FavouriteListSummaryController";
//
//      $scope.summaryDataService = favouriteListSummaryDataService;
//      $scope.projectDataService = projectDataService;
//
//      $scope.$on("NEW_SEARCH", function (event, data) {
//        favouriteListSummaryDataService.items = [];
//        favouriteListSummaryDataService.projectNames = [];
//
//        $state.go("favouriteList");
//      });
//
//      $scope.$emit("DETAIL_PAGE_ACTIVATED", false);
//
//
//      $scope.$on("SORT_CHANGED", function (event, sort) {
//
//        favouriteListSummaryDataService.sorting.sort_order = sort.sortField;
//        favouriteListSummaryDataService.sorting.sort_desc = sort.sortDesc;
//        favouriteListSummaryDataService.paging.offset = 0;
//        favouriteListSummaryDataService.items = [];
//        favouriteListSummaryDataService.count = 0;
//
//        favouriteListSummaryDataService.getFavouriteList($stateParams.favouriteListGuid);
//      });
//
//
//      //////////////////////////////////////////////////////////////////////
//////  Open dialog for Legacy Report Request
//      //////////////////////////////////////////////////////////////////////
//      $scope.openLegacyReportRequestDialog = function () {
//        var projectIDs = projectDataService.projectNames
//          .map(function (item, index, ar) {
//            return item.projectID;
//          }
//        );
//
//        var dlgCreateMemberNote = dialogs.create('/app/reports/legacyReportRequest.dialog.html',
//          'LegacyReportRequestController',
//          { reportParams: {
//            formatID:      0, // Detail
//            title:         "Favourite List - " + favouriteListSummaryDataService.favouriteListName,
//            description:   "",
//            highlightDays: 28,
//            showNotes:     6,
//            sortOrder:     "ProjectName",
//            sortDirection: "ASC",
//            pageBreak:     false,
//            projectIDs:    projectIDs,
//            source:        "DS3 - favourite list"
//          }
//          },
//          {
//            size: 'lg',
//            keyboard: true,
//            backdrop: true,
//            windowClass: 'my-class'
//          }
//        );
//
//        //dlgCreateMemberNote.result.then(function (newMemberNote) {
//        //  projectDataService.projectNotes.unshift(newMemberNote);
//
//        //}, function () {
//        //  // Action upon failure
//        //});
//      };
//
////////////////////////////////////////////////////////////////////////
//
//
//////////////////////////////////////////////////////////////////////
////    $scope.projectIsHidden = function (project) {
////      return (favouriteListSummaryDataService.selectedTrackingStatuses.indexOf(project.trackingStatusID) == -1);
////    };
//////////////////////////////////////////////////////////////////////
//
//
//      $scope.openProject = function (projectID, projectName, allowRevertToSummary) {
//        // close the criteria pane -  find a way to indicate the return path correctly
//
//        projectDataService.revert = {
//          allow: allowRevertToSummary,
//          caption: "Return to Favourite List",
//          go:    function () {
//            $state.go('favourites.favouriteList', favouriteListSummaryDataService.stateParams);
//          }
//        };
//        projectDataService.projectRoute = 'favourites.project';
//        //favouriteListSummaryDataService.allowRevertToSummary = allowRevertToSummary;
//
//        favouriteListSummaryDataService.stateParams = $stateParams;
//        $state.go('favourites.project', { projectID: projectID, projectName: projectName.urlEncode()});
//      };
//
//      $scope.$watch("favouriteListSummaryDataService.favouriteListGuid", function () {
//        $scope.summaryGuid = favouriteListSummaryDataService.favouriteListGuid;
//        $scope.source = "favouritelist"
//      });
//
//      $scope.$on('$viewContentLoaded', function () {
//        favouriteListSummaryDataService.isProject = false;
//        favouriteListSummaryDataService.getFavouriteList($stateParams.favouriteListGuid);
//      });
//
//
//      /**************************************************************************
//       * Action Menu
//       */
//      $scope.exportSummary = function(){
//        return "/api/summaryexport/{{summaryGuid}}?source={{source}}".replace("{{summaryGuid}}", $scope.summaryGuid).replace("{{source}}", $scope.source)
//      };
//
//      $scope.share = function(){
//        return "mailto:?subject=Search Result from EICDataStream&body=I thought you might be interested in this list of projects from EICDataStream:%0D%0A%0D%0A{{currentPath}}%0D%0A%0D%0A".replace("{{currentPath}}", $scope.currentPath());
//      };
//      $scope.actionMenu = {
//        items: [
//
//          {
//            text: "Export Summary",
//            actionType: "href",
//            action: $scope.exportSummary,
//            visible: function() { return true;},
//            disabled:  $scope.areAnyProjectsChecked
//          },
//          {
//            text: "PDF Report...",
//            actionType: "function",
//            action: $scope.openLegacyReportRequestDialog,
//            visible:  function() { return !$scope.areAnyProjectsChecked() && $scope.FEATURE_SWITCHES.LEGACY_REPORT_REQUEST_ENABLED},
//            disabled: false
//          },
//          {
//            text: "PDF of Selected Projects...",
//            actionType: "function",
//            action: $scope.openLegacyReportRequestDialog,
//            visible:  function() { return $scope.areAnyProjectsChecked() && $scope.FEATURE_SWITCHES.LEGACY_REPORT_REQUEST_ENABLED},
//            disabled: false
//          },
//          {
//            text: "Share this search...",
//            actionType: "href",
//            action: $scope.share,
//            visible: function() { return true;},
//            disabled: $scope.areAnyProjectsChecked
//          },
//          {
//            text: "PDF of selected projects...",
//            actionType:"function",
//            action: $scope.openReportRequestDialog_selectedProjects,
//            visible: function(){
//              return $scope.areAnyProjectsChecked() && $scope.NEW_REPORT_REQUEST.SELECTED_PROJECTS_ENABLED
//            },
//            disabled: false
//          },
//          {
//            text: "PDF of results of this search...",
//            actionType:"function",
//            action: $scope.openReportRequestDialog_searchResult,
//            visible: function(){
//              return !$scope.areAnyProjectsChecked() && $scope.NEW_REPORT_REQUEST.CRITERIA_PROJECTS_ENABLED
//            },
//            disabled: false
//          }
//          ,
//          {
//            text: "Watch selected projects...",
//            actionType:"function",
//            action: $scope.openReportRequestDialog_selectedProjects,
//            visible: function(){
//              return $scope.areAnyProjectsChecked() && $scope.WATCHES.SELECTED_PROJECTS_ENABLED
//            },
//            disabled: false
//          },
//          {
//            text: "Watch results of this search...",
//            actionType:"function",
//            action: $scope.openReportRequestDialog_searchResult,
//            visible: function(){
//              return !$scope.areAnyProjectsChecked() && $scope.WATCHES.CRITERIA_PROJECTS_ENABLED
//            },
//            disabled: false
//          }
//        ]
//      }
//
//
//    }]);
//
//
////.controller('FavouriteListNameController', ['$scope', '$state', 'favouriteListSummaryDataService', 'favouriteLists',
////  function ($scope, $state, favouriteListSummaryDataService, favouriteLists) {
////    $scope.favouriteListSummaryDataService = favouriteListSummaryDataService;
////
////
////    $scope.openFavouriteList = function (favouriteListGuid, favouriteListName) {
////      $state.go('favourites.favouriteList', { favouriteListGuid: favouriteListGuid, favouriteListName: favouriteListName.urlEncode()});
////    };
////
////
////    $scope.getFavouriteLists = function () {
////      $scope.favouriteLists = favouriteLists.query();
////    };
////
////    $scope.$on('$viewContentLoaded', function () {
////      favouriteListSummaryDataService.favouriteListName = "";
////      $scope.getFavouriteLists();
////    });
////
//  }]);
